/**
 * Shared layout helpers for inline (legacy) vs full-screen node editors.
 */
export function getEditorContainerProps(presentation, inlineStyle = {}) {
  if (presentation === "fullscreen") {
    return {
      className: "nowheel w-full space-y-5",
      style: {},
      hideHeader: true,
      footerClass:
        "sticky bottom-0 -mx-1 mt-6 pt-4 pb-2 bg-slate-100/95 backdrop-blur border-t border-gray-200 flex gap-3 justify-end",
    };
  }
  return {
    className: "nowheel",
    style: inlineStyle,
    hideHeader: false,
    footerClass: "flex gap-2 mt-3",
  };
}
